import { UserCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext"; // ✅ ใช้ Context

export default function ProfilePanel() {
    const navigate = useNavigate();
    const { user, logout } = useAuth(); // ✅ ดึง user + logout จาก context

    const handleLogout = () => {
        logout();        // ✅ เคลียร์ token + user จาก context/localStorage
        navigate("/login");
    };

    if (!user) return null; // กันไว้กรณี context ยังไม่โหลด

    return (
        <div className="space-y-5 text-sm">
            {/* 🔹 Header */}
            <h2 className="flex items-center gap-2 font-extrabold text-lg text-slate-800 tracking-tight">
                <UserCircle className="text-blue-600" size={20} />
                โปรไฟล์ผู้ใช้งาน
            </h2>

            {/* 🔹 User Card */}
            <div className="bg-white/70 backdrop-blur-xl border border-slate-200 shadow-[0_4px_20px_rgba(59,130,246,0.1)] rounded-2xl p-6 text-center transition-all hover:shadow-[0_6px_25px_rgba(59,130,246,0.15)] hover:border-blue-200">
                <div className="flex flex-col items-center gap-4">
                    <img
                        src={
                            user.image
                                ? user.image
                                : "https://api.dicebear.com/7.x/miniavs/svg?seed=psru"
                        }
                        className="w-24 h-24 rounded-full border-2 border-blue-500 shadow-[0_0_10px_rgba(59,130,246,0.3)]"
                        alt="User Avatar"
                    />

                    <div>
                        <p className="text-lg font-semibold text-slate-800">
                            {user.th_firstname} {user.th_lastname}
                        </p>
                        <p className="text-sm text-slate-500">{user.username}</p>
                    </div>


                    <div className="flex gap-3 mt-3">
                        <button
                            onClick={handleLogout}
                            className="px-5 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-medium text-sm shadow-md shadow-blue-500/30 hover:shadow-lg hover:shadow-blue-500/40 active:scale-95 transition"
                        >
                            ออกจากระบบ
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
